import { Navigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";

const MeaPermissionGuard = ({
  permission,
  fallbackTo = "/",
  hideOnMissingPermission = false,
  children,
}) => {
  const { currentMembership, hasPermission } = useAuthContext();

  if (!currentMembership) {
    return null;
  }

  if (permission && !hasPermission(permission)) {
    if (hideOnMissingPermission) {
      return null;
    }
    return <Navigate to={fallbackTo} replace />;
  }

  return children;
};

export default MeaPermissionGuard;
